export default __webpack_public_path__ + "media/images/icons_fc/user3-e272f6f35221a64c20fa6e5982c65023.png";